// An agent's face, its drawings loaded on first use (./faceDrawing.ts, its own chunk), so the Icon style — Classic's default — costs
// nothing; until they arrive, an empty frame of the same size holds the place (nothing moves when the face appears). Where the document
// already asks for faces at boot (html[data-faces], public/econic-boot.js), the chunk starts loading at once. WP-THEME (23 Oct 2026).
import { lazy, Suspense, type CSSProperties } from "react";
import type { AgentFaceProps } from "../theme/primitives";

const load = () => import("./faceDrawing");
const Face = lazy(() => load().then((m) => ({ default: m.AgentFace })));

if (typeof document !== "undefined") {
  const faces = document.documentElement.dataset.faces;
  if (faces && faces !== "icon") void load();
}

export function LazyAgentFace(props: AgentFaceProps) {
  const frame = { width: props.size, height: props.size, display: "inline-block", flex: "none", verticalAlign: "middle" } as CSSProperties;
  return (
    <Suspense fallback={<span className={props.className} style={frame} aria-hidden />}>
      <Face {...props} />
    </Suspense>
  );
}
